<template>
  <div>
    <div v-if="!replacementItemEnabled">
      Replacement Items not required for this transaction... Please Continue...
    </div>
    <div v-else>
      <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="replacement_item_tooltip_name" :name="replacement_item_tooltip_name" :description="replacement_item_tooltip_description" :editable="editable"></tool-tip>
      <div v-if="!isPartnerAccount">
        <replacement-item-modal
          :is-read-only="isReadOnly || bankingInformationStatus"
          :show-replacement-line-item-modal="showReplacementLineItemModal"
          :id="replacementLineItemId"
          :isNew="isNew"
          v-on:modal-closed="clearModalData"
        >
          <template v-slot:modal-link> ADD </template>
        </replacement-item-modal>

        <replacement-item-all
          :is-read-only="isReadOnly || bankingInformationStatus"
          :id="orderId"
          :isNew="true"
        >
          <template v-slot:modal-link> IMPORT LINE ITEMS </template>
        </replacement-item-all>
        <replacement-item-reorder-enable :is-read-only="isReadOnly || bankingInformationStatus" v-if="!isReorderable"></replacement-item-reorder-enable>
        <replacement-item-reorder :is-read-only="isReadOnly || bankingInformationStatus" v-else></replacement-item-reorder>
      </div>

      <div class="row">
        <div class="col-12">
          <el-table
            :data="replacementItems"
            :summary-method="summary"
            show-summary
            :default-sort="{ prop: 'itemNumber', order: 'ascending' }"
          >
            <el-table-column
              v-if="!isPartnerAccount"
              :min-width="140"
              align="left"
              label="Actions"
            >
              <div slot-scope="props" class="table-actions">
                <el-tooltip
                  content="Delete Replacement Line Item"
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <a
                    @click.prevent
                    v-if="isReadOnly || bankingInformationStatus"
                    href="#"
                    class="btn-link btn-danger btn-disabled"
                    :disabled="deleteDisabled"
                  >
                    <i class="tim-icons icon-trash-simple"></i>
                  </a>
                  <a
                    v-else
                    href="##"
                    @click.prevent="
                      deleteReplacementLineItem(
                        props.row.lineItemId,
                        props.row.stockSubClassName,
                        props.row.itemNumber
                      )
                    "
                    class="btn-link btn-danger"
                  >
                    <i class="tim-icons icon-trash-simple"></i>
                  </a>
                </el-tooltip>
                <el-tooltip
                  content="Edit Replacement Line Item"
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <base-button
                    :disabled="isReadOnly || isPartnerAccount || bankingInformationStatus"
                    class="btn btn-icon btn-fab btn-default btn-sm btn-link"
                    @click.native="viewItem(props.row.lineItemId)"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              sortable
              :key="column.label"
              :min-width="column.minWidth"
              :formatter="column.formatter"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import { BaseSwitch, BaseButton, Modal } from "@/components";
import ReplacementItemModal from "@/components/App/order/submission/replacementitem/ReplacementItemModal.vue";
import ReplacementItemAll from "@/components/App/order/submission/replacementitem/ReplacementItemAll.vue";
import ReplacementItemReorderEnable from "@/components/App/order/submission/replacementitem/ReplacementItemReorderEnable.vue";
import ReplacementItemReorder from "@/components/App/order/submission/replacementitem/ReplacementItemReorder.vue";
import Util from "@/util/util";
import swal from "sweetalert2";
import toolTip  from "../../../Tooltip";

export default {
  props: ["isReadOnly"],
  name: "replacement-item",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    Modal,
    ReplacementItemModal,
    ReplacementItemAll,
    ReplacementItemReorderEnable,
    ReplacementItemReorder,
    toolTip
  },
  data() {
    return {
      showReplacementLineItemModal: false,
      isNew: true,
      replacement_item_tooltip_description:'',
      replacement_item_tooltip_name: '',
      deleteDisabled: false,
      replacementLineItemId: 0,
      tableColumns: [
        {
          prop: "itemNumber",
          label: "Item No",
          minWidth: 120,
        },
        {
          prop: "stockClassName",
          label: "Class of Supply",
          minWidth: 180,
        },
        {
          prop: "stockSubClassName",
          label: "Sub Class",
          minWidth: 200,
        },
        {
          prop: "stockDescription",
          label: "stock No & Description",
          minWidth: 250,
        },
        {
          prop: "unitMeasure",
          label: "Unit Of Measure",
          minWidth: 180,
        },
        {
          prop: "requestedQuantity",
          label: "Request Qty",
          minWidth: 210,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.requestedQuantity);
          },
        },
        {
          prop: "unitPrice",
          label: "Unit Price",
          minWidth: 210,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.unitPrice);
          },
        },
        {
          prop: "partnerItemTotal",
          label: "Partner Total",
          minWidth: 210,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.partnerItemTotal);
          },
        },
        {
          prop: "usItemTotal",
          label: "US Total($)",
          minWidth: 210,
          formatter: (value) => {
            return Util.inMoneyFormatWithoutDollarSign(value.usItemTotal);
          },
        },
      ],
    };
  },
  watch: {
    "replacementItem.stockClassId": function (newValue, oldValue) {
      if (newValue) {
        this.getStockSubClasses(newValue);
      }
    },
  },
  async mounted() {
   await this.getAllTooltips()
    await this.getBankingInformationStatus(this.$route.params.id);
   this.loadToolTips()
 },
  computed: {
    ...mapGetters({
      replacementItem: "replacementItem/replacementItem",
      replacementItems: "replacementItem/replacementItems",
      replacementItemEnabled: "replacementItem/replacementItemEnabled",
      stockClasses: "stockClass/stockClasses",
      stockSubClasses: "stockClass/stockSubClasses",
      unitMeasures: "unitMeasure/unitMeasures",
      orderMetadata: "orderMetadata/orderMetadata",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable",
      bankingInformationStatus: "bankingInformation/bankingInformationStatus",

    }),
    stockSubClassRule() {
      return this.stockSubClasses.length > 0 ? "required" : "";
    },
    orderId() {
      return this.$route.params.id;
    },
    isReorderable() {
      if(this.replacementItems){
      return this.replacementItems.every((i) => !isNaN(i.itemNumber));
     } },
  },
  methods: {
    ...mapActions({
      getReplacementItems: "replacementItem/getReplacementItems",
      getReplacementItemEnabled: "replacementItem/getReplacementItemEnabled",
      getReplacementItem: "replacementItem/getReplacementItem",
      getReplacementItemStatus: "replacementItem/getReplacementItemStatus",
      clearStockSubClass: "replacementItem/clearStockSubClass",
      saveReplacementItem: "replacementItem/saveReplacementItem",
      getStockClasses: "stockClass/getStockClasses",
      getStockSubClasses: "stockClass/getStockSubClasses",
      getUnitMeasures: "unitMeasure/getUnitMeasures",
      getOrderByStatus: "orders/getOrderByStatus",
      removeReplacementItem: "replacementItem/removeReplacementItem",
      updateReplacementLineItems:
        "replacementItem/updateReplacementItemNumbers",
        getAllTooltips: "tooltip/getToolTips",
      getBankingInformationStatus:
        "bankingInformation/getBankingInformationStatus",
    }),

    loadToolTips(){
    const replacementItemToolTip = this.toolTips.find(e => e.name === "ReplacementItemModule")
    if(replacementItemToolTip && replacementItemToolTip.status){
      this.replacement_item_tooltip_description = replacementItemToolTip.description ? replacementItemToolTip.description :  null
      this.replacement_item_tooltip_name = replacementItemToolTip.name ? replacementItemToolTip.name :  null
    }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    loaded() {
      let ctx = this;
      ctx.getReplacementItemEnabled(ctx.$route.params.id).then(() => {
        if (ctx.replacementItemEnabled) {
          ctx.getReplacementItems(ctx.$route.params.id);
        }
      });
    },
    getReplacementItemsLoad(){
      let ctx = this;
      ctx.getReplacementItemEnabled(ctx.$route.params.id).then(() => {
        if (ctx.replacementItemEnabled) {
          ctx.getReplacementItems(ctx.$route.params.id);
        }
      });
    },
    viewItem(replacementLineItemId) {
      let ctx = this;
      ctx.getUnitMeasures();
      ctx.getStockClasses();
      ctx.getReplacementItem(replacementLineItemId).then(() => {
        ctx.errors.clear();
        ctx.replacementLineItemId = replacementLineItemId;
        ctx.showReplacementLineItemModal = true;
        ctx.isNew = false;
      });
    },
    // Clearing Modal data after the modal is closed.
    clearModalData() {
      this.errors.clear();
      this.replacementLineItemId = 0;
      this.showReplacementLineItemModal = false;
      this.isNew = true;
    },
    setItemNumber() {
      let ctx = this;
      //if its  new genrate new item number
      // otherwise get the current postion
      // the add 1 to convert from an index value to an acual number that makes sense to user
      if (ctx.isNew) {
        ctx.replacementItem.itemNumber =
          Math.max.apply(
            Math,
            ctx.replacementItems.map(
              (replacementItem) => replacementItem.itemNumber
            )
          ) + 1;
      }
    },
    generateTotal(values) {
      if (!values.every((value) => isNaN(value))) {
        return values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
      } else {
        return null;
      }
    },
    submit(e) {
      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx.setItemNumber();
          ctx.saveReplacementItem(ctx.$route.params.id).then((response) => {
            ctx.getReplacementItems(ctx.$route.params.id);
            ctx.getOrderByStatus({
              orderStatus: ctx.orderMetadata.orderStatus,
              id: ctx.$route.params.id,
            });
            ctx.getReplacementItemStatus(ctx.$route.params.id);
            ctx.modals.classic = false;
          });
        }
      });
    },
    // Returns updated lineItems with itemNumbers after removing the deleted line item.
    updateReplacementLineItemNumbers(lineItemId) {
      return this.replacementItems
        .filter((lineItem) => lineItem.lineItemId !== lineItemId)
        .map((lineItem, index) => {
          return { lineItemId: lineItem.lineItemId, itemNumber: index + 1 };
        });
    },
    deleteReplacementLineItem(lineItemId, stockSubClassName, itemNumber) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete replacment line item #${itemNumber}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete replacment line item #${itemNumber}!`,
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let ctx = this;
          let replacementLineItemsCount = ctx.replacementItems.length;
          ctx.removeReplacementItem(lineItemId).then((response) => {
            if (replacementLineItemsCount > 1) {
              ctx
                .updateReplacementLineItems(
                  ctx.updateReplacementLineItemNumbers(lineItemId)
                )
                .then(() => {
                  ctx.getReplacementItems(ctx.$route.params.id);
                });
            } else {
              ctx.getReplacementItems(ctx.$route.params.id);
            }
            ctx.getReplacementItemStatus(ctx.$route.params.id);
            new swal({
              title: "Confirmation of Delete",
              text: "Replacement Line item has been deleted successfully.",
              icon: "success",
              confirmButtonColor: "#10b45a",
            });
          });
        }
      });
    },
    getError(fieldName) {
      return Util.transformValidationText(this.errors.first(fieldName));
    },
    stockClassOnChange(value) {
      this.clearStockSubClass();
      this.getStockSubClasses(value);
    },
    summary(param) {
      const { columns, data } = param;
      const sums = [];
      const totalColumns = ["usItemTotal"];
      const quantityColumns = [
        "requestedQuantity",
        "receivedQuantity",
        "unitPrice",
        "partnerItemTotal",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totals";
          return;
        }

        if (quantityColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? Util.inMoneyFormatWithoutDollarSign(total)
            : "0.00";
          if (column.property == "requestedQuantity") {
            sums[index] = total
              ? Util.inMoneyFormatWithoutDollarSign(total)
              : "0.00";
          }
        } else if (totalColumns.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          const total = this.generateTotal(values);
          sums[index] = total
            ? `$ ${Util.inMoneyFormatWithoutDollarSign(total)}`
            : "$ 0.00";
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
  },
};
</script>